// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YbD6","comment":"styles_comment__269Dy"};